
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { OrganizationMergerAcquisitionListItem } from "@gsx/common/src/types/http/dashboard/mergerAcquisition";

@Component({
    components: {},
})
export default class OrganizationTransactions extends Vue {
    @Inject("container") readonly container!: Container;
    @Prop() orgMergerAcquisitions!: OrganizationMergerAcquisitionListItem;
    isOpen = false;

    toggleOpen() {
        this.isOpen = !this.isOpen;
    }

    getTransactions() {}
}
